import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Disclosure } from '@headlessui/react';
import { ChevronUpIcon } from '@heroicons/react/16/solid';
import clsx from 'clsx';
import { schemaHasAttributes } from 'criteria-entity-model';
import { AttributeList } from '../../attribute-list';
export function ParameterChildAttributes({ parameter }) {
    const schema = parameter.schema;
    if (typeof schema !== 'object') {
        return null;
    }
    if (!schemaHasAttributes(schema)) {
        return null;
    }
    // TODO: XML
    return (_jsx(Disclosure, { as: "div", className: "mt-2 rounded-lg border border-zinc-950/10 dark:border-white/10", children: ({ open }) => (_jsxs(_Fragment, { children: [_jsxs(Disclosure.Button, { className: clsx('flex w-full items-start px-1 text-left text-zinc-600 hover:text-zinc-950 dark:text-white/40 dark:hover:text-white', open ? 'border-b border-zinc-950/10 dark:border-white/10' : ''), children: [_jsx(ChevronUpIcon, { className: `${open ? 'rotate-180 transform' : ''} h-5 w-5` }), _jsx("span", { className: "self-center text-xs font-normal", children: open ? 'Hide child attributes' : 'Show child attributes' })] }), _jsx(Disclosure.Panel, { children: _jsx(AttributeList, { schema: schema, parents: [] }) })] })) }));
}
